import { render } from "./XmlMapperHeadList.vue?vue&type=template&id=754556b7&scoped=true&ts=true"
import script from "./XmlMapperHeadList.vue?vue&type=script&lang=ts"
export * from "./XmlMapperHeadList.vue?vue&type=script&lang=ts"

import "./XmlMapperHeadList.vue?vue&type=style&index=0&id=754556b7&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754556b7"]])

export default __exports__